import { Button, makeStyles, alpha, Theme, createStyles } from '@material-ui/core';

interface Props {
  isLinked: boolean;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    linkButton: {
      height: 18,
      width: 64,
      display: 'inline-flex',
      justifyContent: 'center',
      alignItems: 'center',
      padding: '3px 8px 3px 6px',
      borderRadius: 4,
      backgroundColor: theme.palette.action.selected,
      color: theme.palette.text.secondary,
      fontSize: 12,
      fontWeight: 400,
      border: `1px solid ${theme.palette.divider}`,
      '&:hover': {
        backgroundColor: theme.palette.action.selected,
      },
    },
    active: {
      backgroundColor: alpha(theme.palette.primary.main, 0.5),
      '&:hover': {
        backgroundColor: alpha(theme.palette.primary.main, 0.5),
      },
    },
  })
);

const LinkButton = ({ isLinked }: Props) => {
  const classes = useStyles();
  return (
    <Button size="small" className={`${classes.linkButton} ${isLinked && classes.active}`}>
      {isLinked ? 'Linked' : 'Unlinked'}
    </Button>
  );
};

export default LinkButton;
